import { useEffect, useRef } from 'react';
import { toast } from 'react-toastify';

/**
 * Monitors Pusher connection state and triggers a board refresh
 * when reconnecting after a disconnection (events may have been missed).
 */
export function usePusherReconnect({ pusher, onReconnect }) {
  const wasDisconnected = useRef(false);

  useEffect(() => {
    if (!pusher?.connection) return;

    const handleStateChange = ({ previous, current }) => {
      if (current === 'unavailable' || current === 'disconnected') {
        wasDisconnected.current = true;
        toast.warn('Conexión perdida, reconectando...', { autoClose: 3000, toastId: 'pusher-disconnect' });
      }

      if (current === 'connected' && wasDisconnected.current) {
        wasDisconnected.current = false;
        toast.success('Reconectado', { autoClose: 2000, toastId: 'pusher-reconnect' });
        if (onReconnect) onReconnect();
      }
    };

    pusher.connection.bind('state_change', handleStateChange);

    return () => {
      pusher.connection.unbind('state_change', handleStateChange);
    };
  }, [pusher, onReconnect]);
}
